<script setup lang="ts">
import { ref } from 'vue'
import type { FaqItem } from '@/types'

defineProps<{ items: FaqItem[]; title?: string }>()
const open = ref<number | null>(0)
function toggle(i: number) {
  open.value = open.value === i ? null : i
}
</script>

<template>
  <section class="section faq">
    <div class="container">
      <h2>{{ title || 'Questions fréquentes' }}</h2>
      <div class="faq__list">
        <div v-for="(f, i) in items" :key="i" class="faq__item" :class="{ open: open === i }">
          <button
            class="faq__q"
            :aria-expanded="open === i"
            @click="toggle(i)"
          >
            <span>{{ f.question }}</span>
            <span class="faq__icon" aria-hidden="true">{{ open === i ? '−' : '+' }}</span>
          </button>
          <div v-show="open === i" class="faq__a">
            <p>{{ f.answer }}</p>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<style scoped>
.faq {
  background: var(--bg-alt);
}
.faq__list {
  max-width: 900px;
  margin-top: 20px;
}
.faq__item {
  background: #fff;
  border: 1px solid var(--border);
  border-radius: var(--radius);
  margin-bottom: 12px;
  overflow: hidden;
}
.faq__item.open {
  border-color: var(--green);
}
.faq__q {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
  padding: 18px 20px;
  background: none;
  border: none;
  cursor: pointer;
  text-align: left;
  font-family: var(--font-title);
  font-weight: 700;
  font-size: 1rem;
  color: var(--title);
}
.faq__icon {
  flex-shrink: 0;
  width: 28px;
  height: 28px;
  border-radius: 50%;
  background: var(--green);
  color: #272a23;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  font-size: 1.2rem;
  line-height: 1;
}
.faq__a {
  padding: 0 20px 18px;
  color: var(--ink);
}
.faq__a p {
  margin: 0;
}
</style>
